import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    RouterModule,
    AngularSvgIconModule
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  public instagramUrl = 'https://www.instagram.com/hostel.hop?igsh=MWUyZ3l5bDNnNGZ0aA==';
  public tiktokUrl = 'https://www.tiktok.com/@hostelhopofficial?_t=8jksuAKwj56&_r=1';
  public facebookUrl = 'https://www.facebook.com/profile.php?id=61555970164291';
  public twitterUrl = '';
  public linkedinUrl = 'https://www.linkedin.com/company/hostelhopinc';
}
